/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "refund_reversal": {
            "nested": {
              "RefundReversalReason": {
                "values": {
                  "OTHER": 0,
                  "REJECTED": 1,
                  "RISK_REVIEW_REJECTED": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.refund_reversal?.nested?.RefundReversalReason) {
  $root.addJSON(jsonData);
}

/**
 * A reason code explaining why a refund reservation is being reversed. This
 * is not to be confused with a refund reason, which is a reason why a refund
 * is being issued.
 *
 * SOURCE RefundReversalReason @ squareup/payments/refund_reversal.proto at 11:1
 */
export const RefundReversalReason = $root.lookupEnum('squareup.payments.refund_reversal.RefundReversalReason').values;